// extracted by mini-css-extract-plugin
export default {"iframeScrollWrapper":"iframeScrollWrapper-FxXhO","iframeContent":"iframeContent-Ew67H","splashScreen":"splashScreen-oHRcV","loadingWrapper":"loadingWrapper-Z9PXH"};